import { render, staticRenderFns } from "./product2.vue?vue&type=template&id=9805b27a&scoped=true&"
import script from "./product2.vue?vue&type=script&lang=js&"
export * from "./product2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9805b27a",
  null
  
)

export default component.exports